import { Button } from 'antd';
import styled from 'styled-components';

export const MODAL_PADDING = 16;

export const ModalTableWrapper = styled.div`
  margin-inline: -${MODAL_PADDING}px;
`;

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
`;

export interface IAdvancedSelectModalFooterProps {
  onConfirm: () => void;
  onCancel: () => void;
  onClearSelection: () => void;
  showClearSelection: boolean;
  confirmText: string;
  cancelText: string;
  clearSelectionText: string;
}

/**
 * Footer del modal per la selezione avanzata, con i pulsanti di conferma,
 * annullamento e cancellazione selezione.
 */
export function AdvancedSelectModalFooter(
  props: IAdvancedSelectModalFooterProps,
) {
  const {
    onConfirm,
    onCancel,
    onClearSelection,
    showClearSelection,
    confirmText,
    cancelText,
    clearSelectionText,
  } = props;

  return (
    <FooterWrapper>
      <Button type="primary" onClick={onConfirm}>
        {confirmText}
      </Button>
      <Button onClick={onCancel}>{cancelText}</Button>
      {showClearSelection && (
        <Button onClick={onClearSelection}>{clearSelectionText}</Button>
      )}
    </FooterWrapper>
  );
}
